import styled from "styled-components";

export default styled.div.withConfig({
  displayName: "Row",
  componentId: "sc-3jvme5-0"
})(["&:not(:last-child){margin-bottom:1em;}"]);